var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-content-text"},[_c('h4',{staticClass:"post-joke-title"},[_vm._v(_vm._s(_vm.post.header))]),_c('p',{staticClass:"post-joke-text"},[_vm._v(_vm._s(_vm.post.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }